import { CommonEntityDto } from '../../common/dto/common-entity.dto';

import {
  ApiProperty,
  ApiPropertyOptional,
  IntersectionType,
  PickType,
} from '@nestjs/swagger';

import { IsUUID } from 'class-validator';

import { Exclude, Expose } from 'class-transformer';
import { ModelDto } from '../../model/dto/model.dto';
import { PhaseDto } from '../../phase/dto/phase.dto';
import { ModelBoardFloorInterface } from '../interfaces/model-board-floor.interface';
import { BoardPurchaseFloorDto } from '../../board-purchase-floor/dto/board-purchase-floor.dto';

@Exclude()
export class ModelBoardFloorDto
  extends IntersectionType(
    CommonEntityDto,
    // TODO: Use BoardFloorDto?
    PickType(BoardPurchaseFloorDto, [
      'floor',
      'quantity',
      'boardTypeId',
      'boardType',
    ]),
  )
  implements ModelBoardFloorInterface
{
  @ApiProperty({
    format: 'uuid',
    title: 'Model ID',
    description: 'The ID of the Model this material belongs to',
  })
  @IsUUID()
  @Expose()
  modelId!: string;

  @ApiPropertyOptional({
    type: () => ModelDto,
    title: 'Associated Model',
    description: 'The Model this material belongs to',
  })
  @Expose()
  model?: ModelDto;

  @ApiProperty({
    format: 'uuid',
    title: 'Phase ID',
    description: 'The ID of the Phase this material belongs to',
  })
  @IsUUID()
  @Expose()
  phaseId!: string;

  @ApiPropertyOptional({
    type: () => PhaseDto,
    title: 'Associated Phase',
    description: 'The Phase this material belongs to',
  })
  @Expose()
  phase?: PhaseDto;
}
